import {
  faCheckCircle,
  faCircle,
  faCircleQuestion,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

import { calculateCommonCvdValue, CvdKey } from 'src/models/CvdLevel.model';
import { Disease } from 'src/models/Disease.model';
import { handleNSI18Next } from 'src/models/Language.model';
import { Session } from 'src/models/Session.model';

enum CvdRiskThreshold {
  HIGH = 20,
  INTERMEDIATE = 10,
}

interface ICvdRiskData {
  icon: IconDefinition;
  iconText: string;
  className: string;
  desc: string;
  disclaimer?: string;
  shouldShowRiskRecommendation?: boolean;
}

const getCvdRiskData = (session: Session, disease: Disease): ICvdRiskData => {
  const { handleReportT } = handleNSI18Next();

  const cvdRiskValue = calculateCommonCvdValue(session, CvdKey.RISK, disease);

  if (cvdRiskValue === undefined) {
    return {
      icon: faCircleQuestion,
      iconText: handleReportT('cvdSection.cvdRiskData.ungradable.iconText'),
      className: 'bg-secondary',
      desc: handleReportT('cvdSection.cvdRiskData.ungradable.desc'),
    };
  }

  if (cvdRiskValue > CvdRiskThreshold.HIGH) {
    return {
      icon: faTriangleExclamation,
      iconText: handleReportT('cvdSection.cvdRiskData.highRisk.iconText'),
      className: 'bg-danger',
      desc: handleReportT('cvdSection.cvdRiskData.highRisk.desc'),
      disclaimer: handleReportT('cvdSection.cvdRiskData.disclaimer.desc'),
      shouldShowRiskRecommendation: true,
    };
  }

  if (
    cvdRiskValue >= CvdRiskThreshold.INTERMEDIATE &&
    cvdRiskValue <= CvdRiskThreshold.HIGH
  ) {
    return {
      icon: faCircle,
      iconText: handleReportT(
        'cvdSection.cvdRiskData.intermediateRisk.iconText',
      ),
      className: 'bg-warning',
      desc: handleReportT('cvdSection.cvdRiskData.intermediateRisk.desc'),
      disclaimer: handleReportT('cvdSection.cvdRiskData.disclaimer.desc'),
      shouldShowRiskRecommendation: true,
    };
  }

  return {
    icon: faCheckCircle,
    iconText: handleReportT('cvdSection.cvdRiskData.lowRisk.iconText'),
    className: 'bg-success',
    desc: handleReportT('cvdSection.cvdRiskData.lowRisk.desc'),
    disclaimer: handleReportT('cvdSection.cvdRiskData.disclaimer.desc'),
  };
};

export default getCvdRiskData;
